import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
  home: {
    background: '#F3ECE1',

    '& .container': {
      width: 900,
      margin: '0 auto',
      paddingBottom: 100,

      '& .header': {
        textAlign: 'center',

        '& img': {
          width: '100%',
        },
      },

      '& .filter': {
        fontSize: 25,
        color: 'white',
        textAlign: 'center',
        fontWeight: 'bold',
        marginBottom: 16,

        '& img': {
          width: 73,
        },

        '& .term-know': {
          background: '#594FD1',
          opacity: 0.5,

          '&.active': {
            opacity: 1,
          },
        },

        '& .term-multiple': {
          background: '#EE734B',
          opacity: 0.5,

          '&.active': {
            opacity: 1,
          },
        },

        '& .term-avoid': {
          background: '#D24B5A',
          opacity: 0.5,

          '&.active': {
            opacity: 1,
          },
        },

        '& .card': {
          minWidth: 175,
          margin: '0 16px',
          cursor: 'pointer',
        },
      },

      '& .other-actions': {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        marginBottom: 16,
        fontSize: 25,
        color: 'white',
        fontWeight: 'bold',
        width: '100%',

        '& .other-actions >*': {
          flexBasis: 'calc(33%)',
        },

        '& .card': {
          display: 'flex',
          alignItems: 'center',
        },

        '& .random-btn': {
          cursor: 'pointer',
        },

        '& .sort-field': {
          position: 'relative',

          '& .sort-header': {
            cursor: 'pointer',
          },

          '& .sort-list': {
            position: 'absolute',
            width: '100%',
            top: 111,

            '& ul': {
              listStyle: 'none',
              margin: 0,
              padding: '10px 0',
              backgroundColor: 'black',
              borderRadius: 10,

              '& li': {
                cursor: 'pointer',
                padding: '5px 10px',
                '&:hover': {
                  backgroundColor: '#594FD1',
                },
              },
            },
          },
        },

        '& button': {
          outline: 'none',
          border: 'none',
          fontSize: 25,
          color: 'white',
          fontWeight: 'bold',
        },

        '& img': {
          width: 50,
          marginRight: 20,
        },

        '& input': {
          padding: 10,
          fontSize: 25,
          backgroundColor: 'transparent',
          border: 'none',
          outline: 'none',
          color: 'white',
          width: '100%',
        },
      },

      '& .add-new-field': {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',

        '& img': {
          width: 50,
          marginRight: 20,
        },

        '& span': {
          fontSize: 25,
          fontWeight: 'bold',
          color: 'white',
        },
      },

      '& .card': {
        borderRadius: 38,
        background: '#312975',
        padding: 27,
      },

      '& .flex-item': {
        display: 'flex',
        alignItems: 'center',
      },

      '& .word-list': {
        marginTop: 32,

        '& .word-item': {
          display: 'flex',
          padding: 27,
          borderRadius: 38,
          marginBottom: 16,
          width: '100%',
          color: 'white',

          '&.know': {
            backgroundColor: '#594FD1',
          },

          '&.avoid': {
            backgroundColor: '#D24B5A',
          },

          '&.multiple': {
            backgroundColor: '#EE734B',
          },

          '& .left-side': {
            width: '30%',
            marginRight: '3%',

            '& h3': {
              fontSize: 35,
              margin: 0,
            },

            '& .title': {
              fontSize: 25,
              margin: '10px 0 0',
            },

            '& div': {
              textAlign: 'center',
              fontStyle: 'italic',
              maxWidth: 200,
              margin: '0 auto',

              '& p': {
                margin: '10px 0 0',
                fontSize: 16,
              },
            },
          },

          '& .right-side': {
            width: '67%',

            '& p': {
              fontSize: 16,
            },
          },
        },
      },
    },
  },
  paper: {
    position: 'absolute',
    background: '#312975',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 700,
    borderRadius: 28,
    outline: 'none',
    color: 'white',

    '& .MuiFormControl-root': {
      width: '100%',
    },

    '& .actions': {
      marginTop: 20,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      '& button:first-child': {
        marginRight: 16,
      },
    },

    '& .edit-textbox': {
      padding: 10,
      marginTop: 16,
      border: '1px solid #F1F1F1',
    },

    '& .MuiTextField-root': {
      '& label': {
        color: 'white',
      },
    },

    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'white',
      },
      '&:hover fieldset': {
        borderColor: 'white',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'white',
      },
    },
  },

  input: {
    color: 'white',
    borderColor: 'white',
  },

  label: {
    color: 'white',
  },

  button: {
    color: 'white',
    border: '1px solid white',

    '&:hover': {
      border: '1px solid white',
    },
  },
}));
